import BaseModelFactory from './base.factory'
import UserCertificationService from './../services/UserCertification.service'
import UserCertification from './../models/user-certification.model'

class UserCertificationFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search(
      { search, pagination, order_by, method },
      { Service: UserCertificationService, Model: UserCertification }
    )
  static findById = async id =>
    await this._findBy({ id: id }, { Service: UserCertificationService, Model: UserCertification })
  static findAllByUserId = async id =>
    await this._findAllBy({ user_id: id }, { Service: UserCertificationService, Model: UserCertification })
  static create = payload =>
    this._create(payload, {
      Service: UserCertificationService,
      Model: UserCertification,
    })
}

export default UserCertificationFactory
